// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"362":"brand","365":"culture","443":"about","697":"news"}[chunkId] + "." + {"362":"9a6cb62a","365":"78e51417","443":"55a7ca42","697":"835d81b1"}[chunkId] + ".js";
};